function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs17"
}, /*#__PURE__*/React.createElement("style", {
  id: "style2"
}, ".cls-1{fill:url(#Degradado_sin_nombre_2);}"), /*#__PURE__*/React.createElement("linearGradient", {
  gradientTransform: "matrix(1.744969,0,0,1.744969,-57.350317,-78.226909)",
  gradientUnits: "userSpaceOnUse",
  y2: 85.339996,
  x2: 103.3,
  y1: 85.339996,
  x1: 43.27,
  id: "Degradado_sin_nombre_2"
}, /*#__PURE__*/React.createElement("stop", {
  id: "stop4",
  stopColor: "#6f6eff",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  id: "stop6",
  stopColor: "#7569fc",
  offset: 0.13
}), /*#__PURE__*/React.createElement("stop", {
  id: "stop8",
  stopColor: "#875bf3",
  offset: 0.31
}), /*#__PURE__*/React.createElement("stop", {
  id: "stop10",
  stopColor: "#a545e6",
  offset: 0.53
}), /*#__PURE__*/React.createElement("stop", {
  id: "stop12",
  stopColor: "#ce25d2",
  offset: 0.76
}), /*#__PURE__*/React.createElement("stop", {
  id: "stop14",
  stopColor: "#f0b",
  offset: 1
})));

var SvgPlatformLogo = function SvgPlatformLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 143.55745,
    width: 143.43797,
    viewBox: "0 0 143.43797 143.55745",
    "data-name": "Capa 1",
    id: "Capa_1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("rect", {
    y: 5.7236404,
    x: 5.5297427,
    height: 130,
    width: 130,
    id: "rect820",
    style: {
      fill: "#fffffb",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#Degradado_sin_nombre_2)",
      strokeWidth: 1.74496913
    },
    id: "path19",
    d: "M 96.032465,18.304759 H 45.009567 A 26.942321,26.942321 0 0 0 18.154501,45.177282 V 96.26998 a 26.942321,26.942321 0 0 0 26.855066,26.87254 H 68.182759 L 46.108903,95.62434 a 36.644349,36.644349 0 0 1 0.33154,-51.441688 36.906095,36.906095 0 0 1 41.390663,-7.241623 44.531608,44.531608 0 0 1 13.436254,10.923504 l -7.555705,7.224176 Q 84.98681,43.589351 72.649881,43.589351 A 25.145002,25.145002 0 0 0 53.943813,51.284668 25.616145,25.616145 0 0 0 46.388094,70.095438 26.383931,26.383931 0 0 0 71.864645,96.47938 21.149023,21.149023 0 0 0 85.929094,91.244463 18.793315,18.793315 0 0 0 92.908969,78.506192 H 82.526405 A 3.6120857,3.6120857 0 0 1 79.141164,80.87935 H 59.17872 v 0 0 -2.251013 h 13.279213 a 0.92483363,0.92483363 0 0 0 0.924833,-0.924833 v 0 A 0.92483363,0.92483363 0 0 0 72.457933,76.77867 H 59.108921 v -2.285915 h 13.279215 a 0.92483363,0.92483363 0 0 0 0.924832,-0.924825 v 0 A 0.92483363,0.92483363 0 0 0 72.388136,72.643097 H 59.108921 v -2.285915 h 13.279215 a 0.92483363,0.92483363 0 0 0 0.924832,-0.924833 v 0 A 0.92483363,0.92483363 0 0 0 72.388136,68.507515 H 59.108921 V 66.11691 h 20.049693 a 3.6469852,3.6469852 0 0 1 3.367791,2.408052 h 21.864455 v 2.320816 a 48.161143,48.161143 0 0 1 -1.84967,13.959749 30.065816,30.065816 0 0 1 -6.142285,10.557083 l -24.220166,27.7101 H 96.032465 A 26.95977,26.95977 0 0 0 122.90498,96.26998 V 45.177282 A 26.95977,26.95977 0 0 0 96.032465,18.304759 Z",
    className: "cls-1"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlatformLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PlatformLogo.96bf23e8.svg";
export { ForwardRef as ReactComponent };